import React from 'react';
import { IProps as IMapsWysiwygBlockProps } from './MapsWysiwygBlock.interface';
import { MapsWysiwygBlock } from './MapsWysiwygBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

// Interface for props expected from an external source (e.g., CMS)
export interface IMapsWysiwygBlockInputProps {
    heading?: string; // Block heading
    content?: string; // WYSIWYG content
    mapSrc: string; // Source URL for the map
    // Allow passthrough of other props, including BlockWrapper props
    [key: string]: any;
}

/**
 * Maps input props from an external source to the component's props.
 * @param input - The input props from the external source.
 * @returns The mapped props for the MapsWysiwygBlock component.
 */
const mapInputToProps = (input: IMapsWysiwygBlockInputProps): IMapsWysiwygBlockProps => {

    return {
        ...input,
        heading: input.heading || undefined,
        content: input.content || undefined,
        iframeSrc: input.mapSrc
    };
};

const MapsWysiwygBlockTranslation: React.FC<IMapsWysiwygBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={MapsWysiwygBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default MapsWysiwygBlockTranslation;
